/**
 * Legend overlay for H3 hex density layer.
 *
 * Shows color swatches matching the step thresholds in HexDensityLayer.
 * Only visible when the hex density overlay is enabled.
 */

import { memo } from 'react';
import { useSettingsStore } from '../../stores/settingsStore';
import { useAuthStore } from '../../stores/authStore';
import { useIsMobile } from '../../hooks/useIsMobile';

const LEGEND_ITEMS = [
  { color: '#22c55e', label: '1\u20132' },
  { color: '#eab308', label: '3\u20137' },
  { color: '#f97316', label: '8\u201314' },
  { color: '#ef4444', label: '15+' },
] as const;

export const HexDensityLegend = memo(function HexDensityLegend() {
  const enabled = useSettingsStore((state) => state.hexDensityEnabled);
  const isAdmin = useAuthStore((state) => state.user)?.role === 'admin';
  const isMobile = useIsMobile();

  if (!enabled || !isAdmin) return null;

  return (
    <div
      className={`absolute bottom-4 left-4 bg-white/90 dark:bg-gray-800/90 backdrop-blur-sm rounded-lg shadow-md z-10 ${
        isMobile ? 'px-2 py-1.5' : 'px-3 py-2'
      }`}
    >
      <h4 className={`font-semibold text-gray-700 dark:text-gray-200 mb-1 ${
        isMobile ? 'text-[10px]' : 'text-xs'
      }`}>
        Vehicle density
      </h4>
      <div className={`flex ${isMobile ? 'gap-2' : 'gap-3'}`}>
        {LEGEND_ITEMS.map((item) => (
          <div key={item.label} className="flex items-center gap-1">
            <div
              className={`${isMobile ? 'w-2.5 h-2.5' : 'w-3 h-3'} rounded-sm`}
              style={{ backgroundColor: item.color, opacity: 0.7 }}
            />
            <span className={`text-gray-600 dark:text-gray-300 ${
              isMobile ? 'text-[10px]' : 'text-xs'
            }`}>
              {item.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
});
